module.exports = new __parcel__URL__("flare.937e38fe.png").toString();